/**
 * Left-panel instruction headings are snapshotted when steps first appear.
 * Edits in the instruction editor do not change the left heading until re-generate.
 */
export function captureInstructionHeadingsSnapshot(instructions = [], snapshot = {}) {
    const next = { ...snapshot };
    instructions.forEach((inst) => {
        if (!inst.aiSteps?.length) return;
        const key = String(inst.id);
        if (!next[key]) {
            next[key] = (inst.text ?? '').trim();
        }
    });
    return next;
}

export function rebuildInstructionHeadingsSnapshot(instructions = []) {
    const next = {};
    instructions.forEach((inst) => {
        if (!inst.aiSteps?.length) return;
        next[String(inst.id)] = (inst.text ?? '').trim();
    });
    return next;
}
